module.exports = __webpack_public_path__ + "static/media/HR_Labra..8af7f30e.png";